<template>
  <div>
    <v-autocomplete
      ref="contentTypesSelect"
      v-model="content_types"
      :items="contentTypesToShow"
      item-text="name"
      item-value="wtype"
      :label="getLabel('values')"
      multiple
      chips
      clearable
      :error="content_types.length === 0 && errors.length > 0"
    />
    <v-btn outlined @click="previousStep">
      <v-icon class="mr-2">mdi-arrow-left</v-icon>
      {{ getLabel("back") }}
    </v-btn>
    <v-btn class="ml-2" color="success" outlined @click="nextStep">
      {{ getLabel("continue") }}
      <v-icon class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>

import { ref, computed } from '@vue/composition-api';

import { useMainStore } from '../../store/index';
import { getLabel } from '@/utils/index';

export default {
  props: {
    restriction: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  setup (props, { emit }) {
    const store = useMainStore();

    const errors = ref([]);

    const content_types = ref(props.restriction.settings.content_types || []);

    const contentTypesToShow = computed(() => store.contentTypes.filter(c => c.project === props.restriction.project));

    const previousStep = () => {
      let restriction = null;

      if (!props.editMode) {
        restriction = { ...props.restriction };
        content_types.value = [];
        restriction.settings = {};
      }

      emit('previousStep', restriction);
    };

    const nextStep = () => {
      if (content_types.value.length === 0) {
        errors.value = [getLabel('insert_minimum_content_types')];
        emit('showErrors', errors.value);
        return;
      }

      const settings = {
        ...props.restriction.settings,
        content_types: content_types.value
      };

      errors.value = [];
      emit('updateRestriction', { ...props.restriction, settings: settings });
    };

    return {
      getLabel,
      errors,
      content_types,
      contentTypesToShow,
      previousStep,
      nextStep
    };
  }

};
</script>
